<template>
  <div class="canvas-wrap">
    <div class="stage-wrap">
      <div ref="canvasBoxWrap" class="canvas-box-wrap">
        <CorrectCanvas
          ref="correctCanvas"
          v-for="(item, index) in linkDetailList"
          :key="item.pathNum"
          :path-num="item.pathNum"
          :is-show="index === imgIndex"
          :img-url="item.path"
          :cur-brush="curBrush"
          :max-width="maxWidth"
          :max-height="maxHeight"
          @objectSelect="objectSelect"
          :brush-list="brushList"
          @objectDelete="objectDelete"
          :index="index"
        />
      </div>
      <a-button
        type="link"
        :disabled="imgIndex === 0"
        @click="handlePrev"
        class="page-btn page-prev"
      >
        <svg-icon icon="arrawLeft" />
      </a-button>
      <a-button
        type="link"
        :disabled="isLast"
        @click="handleNext"
        class="page-btn page-next"
      >
        <svg-icon icon="arrowRight" />
      </a-button>
    </div>
    <div class="operatebox">
      <div class="answer-btn">
        <!-- 查看答案 -->
        <a-button
          v-if="isShowAnswer"
          @click="showAnswer"
          type="link"
        >
          答案
        </a-button>
      </div>
      <div class="right-outer">
        <div class="operatebox-right">
          <div class="operate-center">
            <div class="center-left" />
            <!-- 批改工具栏 -->
            <ul class="operate-tool">
              <li
                v-for="(item, idx) in brushList"
                :key="item.brushName"
                @click="changeBrush(item)"
              >
                <div
                  class="brush-item"
                  :class="{
                    'cur-brush': item.brushName === brushName
                  }"
                >
                  <BrushOption
                    v-if="item.optionList"
                    :option-list="item.optionList"
                    :item="item"
                    @changeBrushOpt="(opt) => changeBrushOpt(idx, opt)"
                  />
                  <SvgIcon v-else :icon="item.icon" :is-keep="true" />
                </div>
              </li>
              <li><span class="line" /></li>
              <!-- <li @click="changeCanvas('handleModify')" class="edit-tool">
            <a-tooltip placement="top">
              <template slot="title">
                <span>修改批注</span>
              </template>
              <i class="iconfont-new icon-edit-copy icon-tool" />
            </a-tooltip>
          </li> -->
              <li class="edit-tool">
                <a-popconfirm placement="topRight" ok-text="确定" cancel-text="取消" @confirm="changeCanvas('confirmClear')">
                  <template slot="title">
                    <p>确定将所有批改清空吗？</p>
                  </template>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>清屏</span>
                    </template>
                    <i class="iconfont-new icon-clear-copy icon-tool" />
                  </a-tooltip>
                </a-popconfirm>
              </li>
            </ul>
            <div class="center-right" />
          </div>
          <div class="operate-right">
            <!-- 放大、缩小 -->
            <ul class="operate-tool-right">
              <li @click="changeCanvas('zoomOut')">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>放大</span>
                  </template>
                  <i class="iconfont-new icon-zoomOut-copy icon-tool" />
                </a-tooltip>
              </li>
              <li @click="changeCanvas('zoomIn')">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>缩小</span>
                  </template>
                  <i class="iconfont-new icon-zoomIn-copy icon-tool" />
                </a-tooltip>
              </li>
              <li @click="changeCanvas('handlexRotate')">
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>旋转90度</span>
                  </template>
                  <SvgIcon icon="rotate" :is-keep="true" />
                </a-tooltip>
              </li>
              <li class="line-wrap">
                <span class="line" />
              </li>
              <li>
                <p class="page-num">
                  页数: {{ imgIndex + 1 }} / {{ linkDetailList.length }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/static/js/fabric-brush.min.js'
import CorrectCanvas from './CorrectCanvas.vue'
import BrushOption from './BrushOption.vue'
import { brushList } from './brushConf'
import SvgIcon from '@/components/SvgIcon.vue'
import correctLogger from '@/utils/logger/correct.js'

export default {
  components: {
    CorrectCanvas,
    BrushOption,
    SvgIcon
  },
  props: {
    linkTypeName: String,
    query: Object,
    // 学生的 userId
    userId: Number,
    // 环节类型
    linkType: Number
  },
  data() {
    return {
      // 要批改的图片的详情
      linkDetailList: [],
      // 当前批改的图片索引
      imgIndex: 0,
      // 分数所在的图片索引
      scoreIndex: null,
      // 图片的信息
      imgData: new Map(),
      // 当前操作画布的笔刷
      curBrush: null,
      maxWidth: 0,
      maxHeight: 0,
      // 笔刷列表
      brushList
    }
  },
  computed: {
    brushName() {
      const { curBrush } = this
      if (curBrush) {
        return curBrush.brushName
      }
      return ''
    },
    detailLength() {
      return this.linkDetailList.length
    },
    // 是否为日积月累
    isWorkword() {
      return this.linkType === 4
    },
    isLast() {
      if (this.imgIndex === (this.detailLength - 1)) {
        return true
      }
      return false
    },
    // 是否为融汇贯通
    isFirstExamWord() {
      return this.linkType === 5
    },
    // 是否显示查看答案
    isShowAnswer() {
      const { isWorkword, isFirstExamWord } = this
      return isWorkword || isFirstExamWord
    }
  },
  watch: {
    isLast: {
      immediate: true,
      handler(val) {
        this.$emit('isLastChange', val)
      }
    },
    scoreIndex: {
      immediate: true,
      handler(val) {
        this.$emit('scoreIndexChange', val)
      }
    },
    imgIndex(val, oldVal) {
      // 点击上一页、下一页
      this.$nextTick(() => {
        // 页面渲染之后，执行上一页或者下一页的合成操作
        this.createImg(oldVal)
      })
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getCorrectionData().then(() => {
        this.$emit('initSuc', this.imgData)
      })
    },
    /**
     * 获取批改学生的数据
     */
    async getCorrectionData() {
      const { userId, linkType } = this
      const { classTypeId, lessonId, xkhTeacherCourseId } = this.query
      const params = {
        classTypeId: Number(classTypeId),
        lessonId: Number(lessonId),
        xkhTeacherCourseId: Number(xkhTeacherCourseId),
        linkType,
        userId
      }
      // 当前学生不在组内时打开下一份(另一个学生)，不传userID
      if (params.userId === -1) {
        delete params.userId
      }
      const res = await this.$service.correction.getCorrectionList(params)
      this.$emit('afterData', res)
      // 获取画布外部框的宽高
      const canvasBoxWrap = this.$refs.canvasBoxWrap
      const { width: maxWidth, height: maxHeight } = canvasBoxWrap.getBoundingClientRect()
      console.log('maxWidth,maxHeight', maxWidth, maxHeight)
      this.maxWidth = maxWidth
      this.maxHeight = maxHeight
      const { linkDetailList } = res
      if (!linkDetailList) {
        // 没有要批改的数据了
        return
      }
      this.linkDetailList = linkDetailList
      linkDetailList.forEach((item, index) => {
        this.imgData.set(index, {
          // 图片的 url
          url: item.path,
          // canvans 的信息
          canvasData: null,
          // canvas 上所有批注的组件
          objects: null,
          name: `correct-${new Date().getTime()}-${item.pathNum}.jpg`
        })
      })
    },
    /**
     * 合成刚隐藏的画布的图片
     */
    createImg(oldIndex) {
      const { imgData } = this
      const { name } = imgData.get(oldIndex)
      this.$refs.correctCanvas[oldIndex].getImgFile(name, oldIndex)
    },
    /**
     * 当前的画布实例
     */
    getCurCanvas() {
      const correctCanvas = this.$refs.correctCanvas
      if (!correctCanvas) {
        return null
      }
      return correctCanvas[this.imgIndex]
    },
    /**
     * 改变笔刷
     */
    changeBrush(curBrush) {
      const { groupId, lessonId, aiLessonId, classTypeId } = this.$route.query
      if (Object.prototype.toString.call(correctLogger[curBrush.loggerFn]) === '[object Function]') {
        correctLogger[curBrush.loggerFn]({ // 批改笔刷埋点
          studentId: this.userId,
          groupId,
          linkType: this.linkTypeName, // 环节名称
          lessonId,
          aiLessonId,
          courseId: classTypeId,
          brushName: curBrush.tip // 笔刷类型
        })
      }
      const correctCanvas = this.$refs.correctCanvas
      // 笔刷还未初始化完成
      if (!correctCanvas) {
        return
      }
      const { brushName } = curBrush
      // 每一个图片都改变笔刷
      correctCanvas.forEach(cur => {
        // 笔刷初始化完成
        if (cur.brushObject) {
          cur.handleBrush(brushName)
        }
      })
      this.curBrush = curBrush
      // 用于埋点信息
      this.$emit('changeTool', brushName)
    },
    /**
     * 物件被选中
     */
    objectSelect(brushName) {
      const curBrushs = this.brushList.filter(item => item.brushName === brushName)
      if (curBrushs.length) {
        const curBrush = curBrushs[0]
        const curCanvas = this.getCurCanvas()
        // 设置当前使用的笔刷
        curCanvas.setCurFreeBrush(curBrush.brushName)
        // 选中当前使用的笔刷
        this.curBrush = curBrush
      } else {
        // 没有对应的笔刷
        this.curBrush = null
      }
    },
    /**
     * 物件被删除
     */
    objectDelete(objectName) {
      this.$emit('objectDelete', objectName)
    },
    /**
     * 改变笔刷的设置
     */
    changeBrushOpt(idx, { key }) {
      // 注意执行顺序，如果设置笔刷出错，curBrush 不会改变
      const curBrush = {
        ...this.brushList[idx],
        curOption: key
      }
      this.$refs.correctCanvas.forEach(correctCanva => {
        correctCanva.changeBrushOpt(curBrush)
      })
      this.brushList.splice(idx, 1, curBrush)
      this.curBrush = curBrush
    },
    /**
     * 改变画布，如放大、缩小、清屏
     */
    changeCanvas(name) {
      this.$refs.correctCanvas[this.imgIndex][name]()
      this.$emit('changeTool', name)
    },
    /**
     * 上一页
     */
    handlePrev() {
      const { imgIndex } = this
      if (imgIndex === 0) {
        return
      }
      this.imgIndex = imgIndex - 1
      this.$emit('imgPageChange', this.imgIndex)
    },
    /**
     * 下一页
     */
    handleNext() {
      const { detailLength, imgIndex } = this
      if (imgIndex === (detailLength - 1)) {
        return
      }
      this.imgIndex = imgIndex + 1
      this.$emit('imgPageChange', this.imgIndex)
    },
    /**
     * 给图片添加印章
     * onlyChange 如果存在就修改，如果不存在也不添加
     */
    addSeal({ key }, isDelete, onlyChange) {
      if (onlyChange) {
        // 是否存在印章
        let isExist = false
        this.$refs.correctCanvas.forEach(correctCanva => {
          if (correctCanva.sealImg) {
            // 存在印章，把当前印章删掉
            correctCanva.addSeal(null, true)
            isExist = true
          }
        })
        // 印章不存在，不用改变印章的位置了
        if (!isExist) {
          return
        }
      }
      const curCanvas = this.getCurCanvas()
      curCanvas.addSeal(key, isDelete)
    },
    /**
     * 打分
     */
    markScore(score) {
      const correctCanvas = this.$refs.correctCanvas
      // 还没有初始化完成
      if (!correctCanvas) {
        return
      }
      // 分只能打到一个图片上，当有分数的时候，更新那个图片上的分，当没分数的时候，全部删除，在当前页再打
      const { scoreIndex, imgIndex } = this
      // 还有没打分
      if (scoreIndex === null) {
        correctCanvas[imgIndex].markScore(score)
        this.scoreIndex = imgIndex
        return
      }
      if (!score) {
        this.scoreIndex = null
      }
      // 已经打过分了
      correctCanvas.forEach((item, index) => {
        if (!score) {
          // 全删除
          item.markScore()
        } else {
          // 有分数，只更新有分数的那张图，其他的图删除
          if (scoreIndex === index) {
            // 更新
            item.markScore(score)
          } else {
            // 删除
            item.markScore()
          }
        }
      })
    },
    /**
     * 保存所有图片，如果图片被编辑了，则进行上传
     */
    async save(uploadKeys) {
      const { imgData } = this
      const { correctCanvas } = this.$refs
      let canvasTime = new Date().getTime()
      const uploadImgs = []
      const uploadFiles = []
      // 获取上传的签名，初始化的时候已经预获取了，如果 key 过期了再重试一次
      const { signMap, storageTime } = await uploadKeys.getResult()
      const signature = []
      // 点上一页下一页的时候进行了预合成，这里在检测下是不是合成的最新的，如果不是再重新进行合成
      const imgs = correctCanvas.map(cur => {
        let curImg
        const imgIndex = cur.index
        const fileName = imgData.get(imgIndex).name
        try {
          curImg = cur.getImgFile(fileName)
          const { file, pathNum, path, singleCanvasTime } = curImg
          if (file) {
            // 图片批改了，需要上传
            uploadImgs.push({
              path,
              pathNum,
              oldIndex: imgIndex,
              singleCanvasTime
            })
            // 需要上传的文件
            uploadFiles.push(file)
            // 当前文件的上传签名
            signature.push(signMap.get(fileName))
          }
        } catch (e) {
          let errMsg = ''
          if (e && e.message) {
            errMsg = `(${e.message})`
          }
          throw new Error(`合成图片报错，请使用最新谷歌浏览器${errMsg}`, e)
        }
        return curImg
      })
      canvasTime = new Date().getTime() - canvasTime
      const uploadImgUrls = []
      let uploadAllTime
      if (uploadFiles.length) {
        const res = await this.$axxUpload.uploadFilesToAxx(uploadFiles, (progressEvent, sign) => {
          // 进度
          // console.log(sign, progressEvent)
        }, signature)
        console.log('>>>>>图片上传完成', res)
        const results = res.results
        uploadAllTime = res.uploadAllTime
        uploadImgs.forEach(({ oldIndex, pathNum, singleCanvasTime }, index) => {
          const curRes = results[index]
          console.log(curRes)
          if (!curRes || !curRes.body || !curRes.body.url) {
            throw new Error(`七牛服务上传出错(${curRes.uploadStatus})`)
          }
          const curUrl = curRes.body.url
          uploadImgUrls.push({
            url: curUrl,
            singleUploadTime: curRes.uploadTime,
            singleCanvasTime
          })
          imgs[oldIndex] = {
            path: curUrl,
            pathNum
          }
        })
      } else {
        // 打一条日志，没有批改的图片
        this.$emit('noCorrect')
      }
      return {
        imgs,
        uploadAllTime,
        uploadNum: uploadImgUrls.length,
        uploadImgUrls,
        storageTime,
        canvasTime
      }
    },
    /**
     * 查看答案
     */
    showAnswer() {
      this.$emit('showAnswer')
    }
  }
}
</script>
<style lang="less" scoped>
.canvas-wrap {
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .stage-wrap {
    flex: 1;
    overflow: hidden;
    position: relative;
    background: #f2f7fe;
  }
  // :deep(.ant-spin-nested-loading) {
  //   flex: 1;
  //   overflow: hidden;
  // }
  // :deep(.ant-spin-container) {
  //   height: 100%;
  //   position: relative;
  //   background: #f2f7fe;
  // }
  // :deep(.ant-spin) {
  //   top: 50% !important;
  //   transform: translateY(-50%);
  // }
  .canvas-box-wrap {
    height: 100%;
  }
  .page-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: rgba(48, 56, 88, 0.5) !important;
    border: none !important;
    color: #fff !important;
    font-size: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    fill: #fff;
    &[disabled] {
      background: rgba(48, 56, 88, 0.3) !important;
      color: #98A2B2 !important;
      fill: #98A2B2;
    }
  }
  .page-prev {
    left: 20px;
  }
  .page-next {
    right: 20px;
  }
}
.operatebox {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  overflow: hidden;
  ul {
    margin: 0;
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    li {
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .line {
    display: block;
    height: 24px;
    width: 1px;
    background: #EBEDF0;
    margin: 0 16px 0 20px;
  }
  .operate-tool {
    li {
      display: flex;
      align-items: center;
      word-break: keep-all;
      min-width: 48px;
      margin: 0 4px;
      cursor: pointer;
      &.edit-tool {
        margin-right: 24px;
      }
      &:last-child {
        margin-right: 0;
      }
      .brush-item {
        display: inline-flex;
        align-items: center;
        &:hover, &.cur-brush {
          background: #F0F2F4;
        }
      }
    }
    .operate-icon {
      display: inline-block;
      width: 36px;
      height: 36px;
      background: center no-repeat;
      background-size: 100% auto;
      margin: 0 16px;
    }
  }
  .operate-tool-right {
    li {
      margin-right: 16px;
      display: flex;
      align-items: center;
      &.line-wrap {
        margin-right: 8px;
      }
      .line {
        margin: 0;
      }
      .page-num {
        color: #505873;
        font-weight: 700;
        font-size: 14px;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .icon-comment {
    font-size: 36px;
    color: #fd1b1b;
    line-height: 36px;
  }
  .icon-tool {
    color: #70788C;
    font-size: 24px;
  }
}
.right-outer {
  overflow-y: hidden;
  overflow-x: auto;
  flex: 1;
}
.operatebox-right {
  display: flex;
  align-items: center;
  min-width: 700px;
}
.operate-center {
  flex: 1;
  display: flex;
  .center-left {
    flex: 4;
  }
  .center-right {
    flex: 1;
  }
}
.operate-right {
  display: flex;
}
// 批改结果
.operate-result {
  display: flex;
  justify-content: space-between;
  margin-top: 9px;
  :deep(.ant-btn) {
    i {
      letter-spacing: normal !important;
      margin-right: 0 !important;
    };
  }
}
</style>